import { render, staticRenderFns } from "./DatabaseView.vue?vue&type=template&id=6b6a974e"
import script from "./DatabaseView.vue?vue&type=script&lang=js"
export * from "./DatabaseView.vue?vue&type=script&lang=js"
import style0 from "./DatabaseView.vue?vue&type=style&index=0&id=6b6a974e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports